import { showModal, toggleModal } from './core/bootstrap-helpers.js';
import { displayToastrAlert } from './ui/toastr-alert.js';
import { spinnerHtml } from './core/utilities.js';

export function initReturns() {
    var $viewAsAccount = $('#vaa');

    $(document)
        .on('click', '.toggle-return, a[href^="return-form"]', function (e) {
            e.preventDefault();
            const $returnModal = $('#returnModal');
            const $modalBody = $returnModal.find('.modal-body');

            if ($returnModal.length) {
                let urlParams = [];
                let paramString = '';

                const orderId = $(this).attr('data-order-id');

                if (
                    typeof orderId !== typeof undefined &&
                    orderId !== null &&
                    orderId !== false
                ) {
                    urlParams.push('order_id=' + orderId);
                }

                const orderItemId = $(this).attr('data-item-id');

                if (
                    typeof orderItemId !== typeof undefined &&
                    orderItemId !== null &&
                    orderItemId !== false
                ) {
                    urlParams.push('order_item_id=' + orderItemId);
                }

                const orderItemBN = $(e.target).attr('data-item-bn');
                const orderItemPN = $(e.target).attr('data-item-pn');
                const orderItemPO = $(e.target).attr('data-item-po');

                if (
                    typeof orderItemBN !== typeof undefined &&
                    orderItemBN !== null &&
                    orderItemBN !== false
                ) {
                    urlParams.push('order_item_bn=' + orderItemBN);
                }

                if (
                    typeof orderItemPN !== typeof undefined &&
                    orderItemPN !== null &&
                    orderItemPN !== false
                ) {
                    urlParams.push('order_item_pn=' + orderItemPN);
                }

                if (
                    typeof orderItemPO !== typeof undefined &&
                    orderItemPO !== null &&
                    orderItemPO !== false
                ) {
                    urlParams.push('order_item_po=' + orderItemPO);
                }

                if ($viewAsAccount.length) {
                    urlParams.push('au=' + $viewAsAccount.val());
                }

                if (urlParams.length) {
                    paramString = '?' + urlParams.join('&');
                }

                $modalBody.html(
                    '<p class="text-center">' + spinnerHtml('Loading...') + '</p>'
                );
                showModal($returnModal);

                $.ajax({
                    url: '/returns/get_return_form' + paramString,
                    type: 'get',
                    dataType: 'html',
                    success: function (response) {
                        $modalBody.html(response);
                    },
                    error: function () {
                        const error =
                            'Failed to retrieve content for return modal.';
                        $modalBody.html(
                            '<p class="text-center text-danger">' +
                                error +
                                '</p>'
                        );
                        console.error(error);
                    },
                });
            }
        })

        .on('change', '.s_type', function (e) {
            if ($(this).val() === 'CANCEL') {
                $('.return-only').hide();
            } else {
                $('.return-only').show();
            }
        })

        .on('change', '.return-form-input-order_id', function (e) {
            var $form = $(this).closest('form');
            var $orderConf = $form.find('.field-order_conf');
            var $poNum = $form.find('.field-po_num');
            var $freeBrand = $form.find('.field-aaia');
            var $freeBrandName = $form.find('.field-brand_name');
            var $freePN = $form.find('.field-part_number');
            var $orderItem = $form.find('.field-order_item_id');
            var $orderItemInput = $orderItem.find(
                '.return-form-input-order_item_id'
            );
            var value = $(this).val();

            if (value != '') {
                $orderConf.hide();
                $poNum.hide();
                $freeBrand.hide();
                $freeBrandName.hide();
                $freePN.hide();

                $orderItem.show();

                var vaa = $viewAsAccount.length
                    ? '?au=' + $viewAsAccount.val()
                    : '';

                $.ajax({
                    url: '/order/get_order_items_dropdown/' + value + vaa,
                    type: 'get',
                    dataType: 'html',
                    beforeSend: function () {
                        $orderItemInput.html('<option>Loading...</option>');
                    },
                    success: function (response) {
                        $orderItemInput.html(response);
                    },
                });
            } else {
                $orderConf.show();
                $poNum.show();
                $freeBrand.show();
                $freeBrandName.show();
                $freePN.show();
                $orderItem.hide();
                $orderItemInput.html('<option></option>');
            }
        })

        .on('change', '.return-form-input-aaia', function (e) {
            var $form = $(this).closest('form');
            var $brandName = $form.find('.field-brand_name');
            var value = $(this).val();

            if (value != '' && value.toLowerCase() != 'other') {
                $brandName.hide();
            } else {
                $brandName.show();
            }
        })

//        .on('change', '.return-form-input-order_item_id', function (e) {
//            var $form = $(this).closest('form');
//            var $partNumber = $form.find('.field-part_number');
//            var $aaia = $form.find('.field-aaia');
//            var $brandName = $form.find('.field-brand_name');
//            var value = $(this).val();
//
//            if (value != '') {
//                $partNumber.hide();
//                $aaia.hide();
//                $brandName.hide();
//            } else {
//                $partNumber.show();
//                $aaia.show();
//                $brandName.show();
//            }
//        })

        .on('submit', '.return-form', function (e) {
            e.preventDefault();

            var $form = $(this);
            var $button = $form.find('[type="submit"]');
            var $alert = $form.find('.alert');
            var originalText = $button.text();
            var formData = new FormData($form[0]);

            $form.find('[type="file"]');

            $.ajax({
                url: $form.attr('action'),
                type: 'post',
                dataType: 'json',
                processData: false,
                contentType: false,
                cache: false,
                data: formData,
                beforeSend: function () {
                    $button.prop('disabled', true).text('Loading...');
                },
                complete: function () {
                    $button.prop('disabled', false).text(originalText);

                    setTimeout(function () {
                        $alert.hide().empty();
                    }, 3000);
                },
                success: function (response) {
                    if (response.hasOwnProperty('message')) {
                        if (response.success) {
//                            $alert
//                                .removeClass('alert-danger')
//                                .addClass('alert-success');
                            $form.find('.form-control').val('');
                            $form.find('[name="qty"]').val('1');
                            $form
                                .find('[type="checkbox"]')
                                .prop('checked', false);
                        } else {
//                            $alert
//                                .removeClass('alert-success')
//                                .addClass('alert-danger');
                        }
//                        $alert.text(response.message).show();
                        displayToastrAlert('success', response.message);
                    }
                },
                error: function () {
                    var error = 'Failed to submit the return form.';
//                    $alert
//                        .removeClass('alert-success')
//                        .addClass('alert-danger')
//                        .text(error)
//                        .show();
                    displayToastrAlert('error', error);
                    console.error(error);
                },
            });
            toggleModal($form.closest('.modal'));
        });
}
